export enum EnvironmentKeys {
  apiVersion = 'apiVersion',
  apiUrl = 'apiUrl',
  oauthUrl = 'loginData.oauthUrl',
  collabOauthUrl = 'loginData.collabOauthUrl',
  clientId = 'loginData.client_id',
  collabId = 'loginData.collab_id',
  responseType = 'loginData.response_type',
  state = 'loginData.state',
  minimalInvest = 'newInvestment.minimalInvest',
  maximalRegularInvest = 'newInvestment.maximalRegularInvest',
  maximalInitialInvest = 'newInvestment.maximalInitialInvest',
  allowZeroInitialDeposit = 'newInvestment.allowZeroInitialDeposit',
  allowZeroRegularDeposit = 'newInvestment.allowZeroRegularDeposit',
  efektikaRegularInvestDefault = 'newInvestment.efektikaRegularInvestDefault',
  efektikaInitialInvestDefault = 'newInvestment.efektikaInitialInvestDefault',
  headerNotificationsBellUpdateInMiliseconds = 'headerNotificationsBellUpdateInMiliseconds',
  oneTimeSpecificCode = 'paymentCodes.specificOneTime',
  regularSpecificCode = 'paymentCodes.specificRegular',
  logoutAfterIdleForMinutes = 'logoutAfterIdleForMinutes',
  posthogInstanceAddress = 'posthog.instanceAddress',
  posthogOptInSiteApps = 'posthog.optInSiteApps',
  posthogProjectApiKey = 'posthog.projectApiKey',
  cookieConsentDocumentLink = 'cookieConsentDocumentLink',
  investmentQuestionaireExternalUrl = 'externalUrls.investmentQuestionaireAgain',
  amlFormExternalUrl = 'externalUrls.amlForm',
  appInAppleAppStoreExternalUrl = 'externalUrls.appInAppleAppStore',
  appInAndroidGoogleStoreExternalUrl = 'externalUrls.appInAndroidGoogleStore',
  limitForInvestmentCreateConfirm = 'limitForInvestmentCreateConfirm',
  weeklyFrequency = 'summary.investmentPeriods.weekly',
  monthlyFrequency = 'summary.investmentPeriods.monthly',
  quarterlyFrequency = 'summary.investmentPeriods.quarterly',
  unknownFrequency = 'summary.investmentPeriods.na',
  bwmAppLink = 'appLinks.bwm',
  bwmWorkplaceLink = 'appLinks.workplace',
}

export enum TestEnvironmentKeys {
  testUserExOnlyEmail = 'ex_only_email',
  testUserExOnlyPass = 'ex_only_pass',
  testUserPortfMngEmail = 'portf_mng_email',
  testUserPortfMngPass = 'portf_mng_pass',
  testUserPortfMngWSEmail = 'portf_mng_ws_email',
  testUserPortfMngWSPass = 'portf_mng_ws_pass',
  testUserCanReadEnglishEmail = 'can_read_english_email',
  testUserCanReadEnglishPass = 'can_read_english_pass',
  testUserReadEnglishCheckedEmail = 'read_english_checked_email',
  testUserReadEnglishCheckedPass = 'read_english_checked_pass',
}

export const riscScoreVideos: Record<string, string> = {
  defensiveRiscScoreVideo: 'riscScoreVideoLinks.defensive',
  cautiousRiscScoreVideo: 'riscScoreVideoLinks.cautious',
  conservativeRiscScoreVideo: 'riscScoreVideoLinks.conservative',
  balancedRiscScoreVideo: 'riscScoreVideoLinks.balanced',
  dynamicRiscScoreVideo: 'riscScoreVideoLinks.dynamic',
  stockRiscScoreVideo: 'riscScoreVideoLinks.stock',
}

export interface EnviromentConfig {
  production: boolean,
  configSource: string,
}
